import React from "react";
import { Row, Col } from "antd";
import {
  BookOutlined,
  CodeOutlined,
  DatabaseOutlined,
  RightOutlined,
  HddOutlined,
  AppstoreOutlined,
  UserOutlined,
} from "@ant-design/icons";

import "./NavigationFooter.scss";

export default function NavigationFooter() {
  return (
    <Row className="navigation-footer">
      <Col>
        <h3>Navegación</h3>
      </Col>
      <Row className="navigation-footer">
        <Col md={12}>
          <RenderListLeft />
        </Col>
        <Col md={12}>
          <RenderListRight />
        </Col>
      </Row>
    </Row>
  );
}

function RenderListLeft() {
  return (
    <ul>
      <li>
        <a href="https://www.udemy.com/">
          <BookOutlined /> Cursos Online
        </a>
      </li>
      <li>
        <a href="https://www.udemy.com/">
          <CodeOutlined /> Desarrollo web
        </a>
      </li>
      <li>
        <a href="https://www.udemy.com/">
          <DatabaseOutlined /> Base de Datos
        </a>
      </li>
      <li>
        <a href="https://www.udemy.com/">
          <RightOutlined /> Politica de Privacidad
        </a>
      </li>
    </ul>
  );
}

function RenderListRight() {
  return (
    <ul>
      <li>
        <a href="https://www.udemy.com/">
          <HddOutlined /> Sistemas / Servidores
        </a>
      </li>
      <li>
        <a href="https://www.udemy.com/">
          <AppstoreOutlined /> CMS
        </a>
      </li>
      <li>
        <a href="https://www.udemy.com/">
          <UserOutlined /> Portafolio
        </a>
      </li>
      <li>
        <a href="https://www.udemy.com/">
          <RightOutlined /> Política de Cookies
        </a>
      </li>
    </ul>
  );
}
